<template>
    <v-container fluid grid-list-md class="grey lighten-4">
        <v-card class="height-auto">
            <v-card-title>
                <span>Add Payment Income</span><br>
            </v-card-title>
            <v-container fill-height fluid>
                <v-flex xs12 sm12>
                    <PaymentForm></PaymentForm>
                </v-flex>
            </v-container>
        </v-card>

        <v-layout row class="padding">
            <v-flex xs12 sm12>
                <ProjectPerUsersPickers @change="requestData"></ProjectPerUsersPickers>
            </v-flex>
        </v-layout>
        <v-layout row class="padding">
            <v-flex xs12 sm12>
                <Loader v-if="loading"></Loader>
                <div class="text-xs-center margin-top">
                    <v-pagination :length="params.totalProjects" v-model="params.projectsPage" circle></v-pagination>
                </div>
                <table border="1" class="width">
                    <caption>Users/Projects</caption>
                    <tr>
                        <th>Users/Projects</th>
                        <th v-for="header in data.headers" :key="header">{{header}}</th>
                    </tr>
                    <tr v-for="AnalyticsObject in data.Analytics" :key="AnalyticsObject.User.id">
                        <td>
                            <v-list slot="activator">
                                <v-list-tile @click="goToUser(AnalyticsObject.User.id)">
                                    <v-list-tile-action>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-text="AnalyticsObject.User.first_name"></v-list-tile-title>
                                        <v-list-tile-title v-text="AnalyticsObject.User.last_name"></v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-avatar>
                                        <img :src="AnalyticsObject.User.avatar_url">
                                    </v-list-tile-avatar>
                                </v-list-tile>
                            </v-list>
                        </td>
                        <td v-for="ProjectAnalytics in AnalyticsObject.Analytics " :key="ProjectAnalytics.Project.id">
                            <v-tooltip top>
                                <v-list slot="activator">
                                    <v-list-tile @click="">
                                        <v-list-tile-action>
                                            <v-icon color="grey">all_inclusive</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title v-text="ProjectAnalytics.totalHours"></v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-avatar>
                                        </v-list-tile-avatar>
                                    </v-list-tile>
                                    <v-list-tile @click="">
                                        <v-list-tile-action>
                                            <v-icon color="grey">trending_up</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title
                                                v-text="ProjectAnalytics.billableHours"></v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-avatar>
                                        </v-list-tile-avatar>
                                    </v-list-tile>
                                    <v-list-tile @click="">
                                        <v-list-tile-action>
                                            <v-icon color="grey">trending_flat</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title
                                                v-text="ProjectAnalytics.nonBillableHours"></v-list-tile-title>
                                        </v-list-tile-content>
                                        <v-list-tile-avatar>
                                        </v-list-tile-avatar>
                                    </v-list-tile>
                                </v-list>
                                <span>
                                    <span>{{ProjectAnalytics.Project.name}}</span>
                                    <v-divider inset></v-divider>
                                    <span>Revenue:{{ProjectAnalytics.Revenue}}$</span>
                                    <v-divider inset></v-divider>
                                    <span>Total Revenue: {{AnalyticsObject.Revenue}}$</span>
                                </span>
                            </v-tooltip>
                        </td>
                    </tr>
                </table>
                <v-btn v-if="!loading" round color="margin-top grey-primary "
                       :disabled="params.usersPage==params.totalUsers" @click="loadMore">Load More Users
                </v-btn>
                <Loader v-if="loading"></Loader>
                <div class="text-xs-center margin-top ">
                    <v-pagination :length="params.totalProjects" v-model="params.projectsPage" circle></v-pagination>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
    import {
        Api
    } from '../../../../services';
    import queryString from 'query-string';
    import Loader from '../../Components/Loader.vue';
    import ProjectPerUsersPickers from './ProjectPerUsersPickers.vue';
    import PaymentForm from '../../Components/Forms/PaymentForm.vue';

    import _ from 'lodash';
    export default {
        name: 'UsersPerProject',
        data() {
            return {
                msg: 'Pleaase wait ...',
                subdomain: 'hat',
                client_id: '-PsAjA85atcU6QvOwHP2qA',
                redirect_uri: 'http://localhost:8080',
                items: [],
                data: {
                    headers: [],
                    Analytics: []
                },
                params: {
                    projectsPage: 1,
                    usersPage: 1,
                    totalUsers: 1,
                    totalProjects: 1,
                    from: new Date(new Date() - 1000 * 60 * 60 * 24 * 31 - 1).toISOString(),
                    to: new Date().toISOString()
                },
                loading: true
            }
        },
        components: {
            Loader,
            ProjectPerUsersPickers,
            PaymentForm
        },
        watch: {
            'params.projectsPage': function (newValue, oldValue) {
                if (oldValue !== newValue) {
                    this.usersPage = 1;
                    this.requestData({
                        projectsPage: newValue
                    })
                }
            }
        },
        created() {
            this.requestData()
        },
        methods: {
            auth() {
            },
            requestData(params) {
                this.loading = true;
                Api
                .Analytics()
                .ProjectsPerUsers(Object.assign(this.params, params))
                .then((res) => {
                    this.data = res.data;
                    this.params.totalProjects = res.data.totalProjects;
                    this.params.totalUsers = res.data.totalUsers;
                    this.params.usersPage = res.data.usersPage;
                    this.params.projectsPage = res.data.projectsPage;
                    return this.items
                })
                .then(() => this.loading = false)
                .catch(err => {
                    this.loading = false
                })
            },
            loadMore() {
                this.params.usersPage++;
                this.loading = true;
                Api
                .Analytics()
                .ProjectsPerUsers(this.params)
                .then((res) => {
                    let newAnalytics = _.concat(this.data.Analytics, res.data.Analytics);
                    this.data = res.data;
                    this.data.Analytics = newAnalytics
                    this.params.totalProjects = res.data.totalProjects;
                    this.params.totalUsers = res.data.totalUsers;
                    this.params.usersPage = res.data.usersPage;
                    this.params.projectsPage = res.data.projectsPage;
                    return this.items
                })
                .then(() => this.loading = false)
                .catch(err => {
                    this.loading = false
                })
            },
            goToUser(user_id) {
                this.$router.push(`/admin/analytics/users-per-project?user_id=${user_id}`);
            }
        }
    }
</script>

<style>
    .height {
        height: 100%
    }

    .height-auto {
        height: auto;
    }

    .height .list__tile {
        height: 100%
    }

    .card__title {
        font-size: 2rem;
    }

    .list-tile-margin {
        height: 40px;
    }

    .card-title-margin {
        margin-left: 23px;
    }

    .width {
        width: 100%;
        border-collapse: collapse;
    }

    .margin-top {
        margin-top: 40px
    }

    .grey-primary {
        background-color: #686666 !important;
        color: white !important;
    }

    .pagination__item--active {
        background-color: #686666 !important;
        background: #686666 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Analytics/ProjectPerUsers/ProjectPerUsers.vue